module.exports = __webpack_public_path__ + "static/media/backArrowIcon.a31021d8.svg";